export const whileInView10once = {
  initial: 'offscreen',
  whileInView: 'onscreen',
  viewport: { once: true, amount: 0.1 },
};
export const whileInView30once = {
  initial: 'offscreen',
  whileInView: 'onscreen',
  viewport: { once: true, amount: 0.3 },
};
export const whileInView100once = {
  initial: 'offscreen',
  whileInView: 'onscreen',
  viewport: { once: true, amount: 1 },
};
